// @flow
import * as React from 'react';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { IntlShape, injectIntl } from 'react-intl';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import point11Messages from 'esm-web-pro/messages/points11Messages';
import type { RackDetailedRepresentation } from 'esm-web-pro/types/networks';

type Props = {
    rack: RackDetailedRepresentation,
    url: string,
    intl: IntlShape,
    onView: Function,
}

const RackAttributes = (props: Props) => {
    const {
        rack, url, intl: { formatMessage }, onView,
    } = props;

    const {
        pop: container, heightU, provider_ref: providerRef,
    } = rack;

    const attributes = [
        {
            label: formatMessage(attributeMessages.ref),
            value: rack.ref,
            onClick: onView,
        },
        {
            label: formatMessage(attributeMessages.container),
            value: `${formatMessage(point11Messages[container.type])} ${
                container.type === 'pop' && container.alias
                    ? container.alias
                    : container.sequence
            }`,
            link: `${url.split('/layer')[0]}/layer/${container.type}/${container.identity}`,
        },
        {
            label: formatMessage(attributeMessages.height),
            value: heightU,
        },
        {
            label: formatMessage(attributeMessages.providerRef),
            value: providerRef,
        },
    ];

    return (
        <Attributes attributes={attributes} />
    );
};

export default injectIntl(RackAttributes);
